"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrgBranch = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const organisation_entity_1 = require("./organisation.entity");
let OrgBranch = class OrgBranch {
};
exports.OrgBranch = OrgBranch;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OrgBranch.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: 'organisation_id', type: 'int' }),
    tslib_1.__metadata("design:type", Number)
], OrgBranch.prototype, "organisationId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: 'name', type: 'varchar', length: 255 }),
    tslib_1.__metadata("design:type", String)
], OrgBranch.prototype, "name", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: 'description', type: 'text', nullable: true }),
    tslib_1.__metadata("design:type", Object)
], OrgBranch.prototype, "description", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: 'created_at', type: 'timestamptz', default: () => 'CURRENT_TIMESTAMP' }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], OrgBranch.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({ name: 'updated_at', type: 'timestamptz', default: () => 'CURRENT_TIMESTAMP' }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], OrgBranch.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: 'created_by', type: 'varchar' }),
    tslib_1.__metadata("design:type", String)
], OrgBranch.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: 'updated_by', type: 'varchar' }),
    tslib_1.__metadata("design:type", String)
], OrgBranch.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => organisation_entity_1.Organisation, { onDelete: 'CASCADE' }),
    (0, typeorm_1.JoinColumn)({ name: 'organisation_id' }),
    tslib_1.__metadata("design:type", typeof (_c = typeof organisation_entity_1.Organisation !== "undefined" && organisation_entity_1.Organisation) === "function" ? _c : Object)
], OrgBranch.prototype, "organisation", void 0);
exports.OrgBranch = OrgBranch = tslib_1.__decorate([
    (0, typeorm_1.Entity)('org_branch')
], OrgBranch);
